import React from 'react';

interface Props {
  score?: number;
  disabled?: boolean;
}

const Score: React.FC<Props> = ({ score, disabled = false }) => {
  const commonScoreClassName: string =
    'flex font-medium items-center justify-center w-16 h-8 rounded-full whitespace-no-wrap';
  const scoreTestID: string = 'scoreTestID';

  if (score === undefined || score === null) {
    return (
      <div className={commonScoreClassName} data-testid={scoreTestID}>
        Not Taken
      </div>
    );
  }
  const label: string = `${score} pts`;
  if (disabled) {
    return (
      <div
        className={`${commonScoreClassName} text-gray-500 bg-gray-200`}
        data-testid={scoreTestID}
      >
        {label}
      </div>
    );
  }

  let colorClass: string;
  if (score >= 64) {
    colorClass = 'text-teal-600 bg-teal-100';
  } else if (score >= 29) {
    colorClass = 'text-orange-500 bg-orange-200';
  } else {
    colorClass = 'text-pink-500 bg-pink-100';
  }

  return (
    <div className={`${commonScoreClassName} ${colorClass}`} data-testid={scoreTestID}>
      {label}
    </div>
  );
};

export default Score;
